import { backendApi } from "../dynamicBAseQuery";

export const PaymentHistory=backendApi.injectEndpoints({
    overrideExisting:true,
    endpoints:(builder)=>({
        getRecruiterPaymentList:builder.mutation({
            query:(args)=>({
                method:"POST",
                url:'getRecruiterPaymentList',
                body:{...args}
            })
        }),

        getRecruiterPaidAmountList:builder.mutation({
            query:(args)=>({
                method:"POST",
                url:'getRecruiterPaidAmountList',
                body:{...args}
            })
        }),

        getRecruiterUnPaidAmountList :builder.mutation({
            query:(args)=>({
                method:"POST",
                url:'getRecruiterUnPaidAmountList ',
                body:{...args}
            })
        }),

        getRecruiterRefundAmountList :builder.mutation({
            query:(args)=>({
                method:"POST",
                url:'getRecruiterRefundAmountList ',
                body:{...args}
            })
        }),

        getRecruiterPendingAndRefundList :builder.mutation({
            query:(args)=>({
                method:"POST",
                url:'getRecruiterPendingAndRefundList',
                body:{...args}
            })
        }),

        InvoiceSave :builder.mutation({
            query:(args)=>({
                method:"POST",
                url:'InvoiceSave',
                body:{...args}
            })
        }),

        getInvoiceIdList :builder.mutation({
            query:(args)=>({
                method:"POST",
                url:'getInvoiceIdList',
                body:{...args}
            })
        }),


    })
})
export const {
    useGetRecruiterPaymentListMutation,
    useGetRecruiterPaidAmountListMutation,
    useGetRecruiterUnPaidAmountListMutation,
    useGetRecruiterRefundAmountListMutation,
    useGetRecruiterPendingAndRefundListMutation,
    useInvoiceSaveMutation,
    useGetInvoiceIdListMutation,
}=PaymentHistory